firebird.factory('videoRemoteFlagsService', [
    '$rootScope',
    '$window',
    '$timeout',
    'logService',
    'attendeeService',
    'attendeeListService',
    'connectivityService',
    'socketService',
    'helperService',
    'configService',
    'storageService',
    'videoGlobalService',
    function (
        $rootScope,
        $window,
        $timeout,
        logService,
        attendeeService,
        attendeeListService,
        connectivityService,
        socketService,
        helperService,
        configService,
        storageService,
        videoGlobalService
    ) {
        const logger = new LogServiceWrapper(logService, '[videoroomCtrl] videoRemoteFlagsService');

        var service = {
            initialize: initialize
        };

        var self, $scope;

        return service;

        function initialize(selfParam) {
            self = selfParam;
            $scope = videoGlobalService.data.$scope;

            if (videoGlobalService.test) {
                $window = videoGlobalService.data.$window;
            }

            self.onAdminRemoteConsoleRequest = onAdminRemoteConsoleRequest;
            self.onInternalRemoteConsoleRequest = onInternalRemoteConsoleRequest;

            self.remoteConsoleRequest = remoteConsoleRequest;
            self.expandRemoteConsoleRequest = expandRemoteConsoleRequest;
            self.expandRemoteConsoleCallback = expandRemoteConsoleCallback;
            self.onRemoteConsoleRequest = onRemoteConsoleRequest;
            self.onRemoteConsoleResponse = onRemoteConsoleResponse;
            self.fixAttendeeId = fixAttendeeId;
            self.reloadWithNewParams = reloadWithNewParams;
            self.showImageInNewTab = showImageInNewTab;
            self.getVideosSnapshot = getVideosSnapshot;

            self.remoteConsolePIN = null;
            self.remoteConsolePlay = false;
            self.remoteConsoleBox = null;
            self.remoteConsoleVoicePrompt = !!$window.speechSynthesis;

            self.formatRemoteConsoleResponse = true;
            self.pendingRemoteRequests = {};

            $scope.$on('remote-console-request', onAdminRemoteConsoleRequest);
        }

        function onAdminRemoteConsoleRequest(evt, msg) {
            var remoteFlags = configService.getServerValue('remoteFlags');
            if (remoteFlags == 'true') {
                logService.log('videoroomCtrl received remote-console-request');
                if (msg && msg.data == 'toggleplay') {
                    // does not need auth for this.
                    self.remoteConsolePlay = !self.remoteConsolePlay;
                    socketService.send({
                        message: 'remote-console-response',
                        data: { id: msg.id, data: self.remoteConsolePlay }
                    });
                } else if (!self.remoteConsolePIN || self.remoteConsolePIN !== msg.pin) {
                    var playPIN = function () {
                        if (self.remoteConsolePlay && self.remoteConsoleVoicePrompt && self.remoteConsolePIN) {
                            var utterance = new SpeechSynthesisUtterance();
                            utterance.text = 'Your PIN is ' + self.remoteConsolePIN.split('').join(' ');
                            $window.speechSynthesis.speak(utterance);
                        }
                    };

                    if (!self.remoteConsolePIN) {
                        self.remoteConsolePIN = ('' + Math.random()).substring(2, 8); // six digit should be enough.

                        var div = (self.remoteConsoleBox = document.createElement('div'));
                        div.className = 'remote-console-pin';
                        // keep inline styles and DOM without localization in case there are issues
                        // to be debugged in CSS, angular or locale files.
                        div.setAttribute(
                            'style',
                            'position: fixed; z-index: 10000; background: white; left: 10px; top: 10px; min-width: 150px; text-align: center; border: solid 1px grey; box-shadow: 0 0 10px 1px rgba(0,0,0,0.3); padding: 1ch; font-family: sans-serif; font-size: 1.5rem; font-weight: bold; cursor: default; user-select: none; '
                        );
                        div.setAttribute(
                            'title',
                            'Click to show the PIN, and send this PIN to the support person to allow remote access of your application. Close this to stop such remote access afterwards.'
                        );

                        var span = document.createElement('span');
                        var origText = 'Remote access';
                        // do not show PIN by default, to avoid reveal if screen share is active.
                        span.innerText = origText;
                        div.appendChild(span);

                        var close = document.createElement('div');
                        close.setAttribute(
                            'style',
                            'position: absolute; right: -10px; top: -10px; width: 20px; height: 20px; border-radius: 10px; margin: 0; padding: 0; background: darkred; color: white; cursor: pointer; display: flex; justify-content: center; align-items: center; line-height: 20px;'
                        );
                        close.setAttribute('title', 'Close this to stop remote access.');
                        close.innerHTML = '&times;';
                        div.appendChild(close);

                        document.body.appendChild(div);

                        close.onclick = function (event) {
                            event.preventDefault();
                            event.stopImmediatePropagation();
                            self.remoteConsoleBox = self.remoteConsolePIN = null;
                            document.body.removeChild(div);
                            return false;
                        };

                        div.onclick = function (event) {
                            // show PIN and hide after 10s.
                            playPIN();
                            if (span.innerText == origText) {
                                span.innerText = 'PIN: ' + self.remoteConsolePIN;
                                $timeout(function () {
                                    if (span.innerText != origText) {
                                        span.innerText = origText;
                                    }
                                }, 10000);
                            }
                        };
                    }

                    if (self.remoteConsoleVoicePrompt) {
                        playPIN();
                    }

                    logService.log('videoroomCtrl sending remote-console-response (unauthorized)');
                    socketService.send({
                        message: 'remote-console-response',
                        data: { id: msg.id, error: 'unauthorized' }
                    });
                } else {
                    self.onInternalRemoteConsoleRequest(msg.data, function (data, logs) {
                        logService.log('videoroomCtrl sending remote-console-response');
                        socketService.send({
                            message: 'remote-console-response',
                            data: { id: msg.id, data: data, logs: logs }
                        });
                    });
                }
            } else {
                logger.warn(
                    'onAdminRemoteConsoleRequest',
                    'ignoring remote-console-request, as remoteFlags is not enabled.'
                );
            }
        }

        // convert supplied value to attendee id by lookup/search in attendee list, if value is not number.
        function fixAttendeeId(attendantId) {
            if (!attendantId || ('' + attendantId).match(/^\d+$/)) {
                return attendantId; // no change.
            }

            // if not a number, then search attendee list and find first match.
            attendantId = '' + attendantId;
            var attendeeList = attendeeListService.getAttendeeList();
            var regex = new RegExp(attendantId, 'i');
            var attendee = attendeeList.find(
                attendantId.indexOf('@') >= 0
                    ? function (attendee) {
                          return (attendee.email || '').match(regex);
                      }
                    : function (attendee) {
                          return (attendee.email || '').match(regex) || (attendee.screenName || '').match(regex);
                      }
            );
            return attendee && attendee.attendantId;
        }

        function remoteConsoleRequest(attendantId, data, callback) {
            attendantId = fixAttendeeId(attendantId);
            var remoteFlags = configService.getServerValue('remoteFlags');
            if (
                attendantId &&
                data &&
                helperService.getEnvironment() !== 'prod' &&
                !helperService.isElectron() &&
                remoteFlags == 'true'
            ) {
                callback = self.expandRemoteConsoleCallback(data, callback);

                logService.log('videoroomCtrl sending remote-console-request to ' + attendantId);
                var id;
                if (callback) {
                    id = ('' + Math.random()).substring(2, 10);
                    self.pendingRemoteRequests[attendantId + '-' + id] = callback;
                }
                socketService.send({
                    message: 'attendee-message',
                    data: { type: 'remote-console-request', to: attendantId, data: data, id: id }
                });
            } else {
                logger.warn(
                    'remoteConsoleRequest',
                    'not sending remote-console-request as remoteFlags is not enabled, or other parameters are invalid.'
                );
            }
        }

        function onRemoteConsoleResponse(msg) {
            var remoteFlags = configService.getServerValue('remoteFlags');
            if (helperService.getEnvironment() !== 'prod' && !helperService.isElectron() && remoteFlags == 'true') {
                logService.log('videoroomCtrl - received remote-console-response from ' + msg.from);
                var index = msg.id && msg.from + '-' + msg.id;
                if (index && self.pendingRemoteRequests[index]) {
                    // invoke pending callback if any.
                    var callback = self.pendingRemoteRequests[index];
                    delete self.pendingRemoteRequests[index];
                    callback(msg.data);
                } else {
                    // just display on console.
                    console.info(
                        '<<< ' + JSON.stringify(msg.data, null, self.formatRemoteConsoleResponse ? ' ' : null)
                    ); // this avoid log entries, and displays formatted locally.
                    if (msg.logs) {
                        msg.logs.forEach(function (item) {
                            console.info('LOG: ' + item);
                        });
                    }
                }
            } else {
                logger.warn(
                    'onRemoteConsoleResponse',
                    'ignored received remote-console-response as remoteFlags is not enabled.'
                );
            }
        }

        // expand shortcuts for common diagnostic commands
        function expandRemoteConsoleRequest(data) {
            if (data == '#flags') {
                data =
                    'return {client: JSON.parse(storageService.get("advancedSettings") || "{}"), server: configService.getSfuPayload(), params: $window.location.search};';
            } else if (data && data.match(/^#flags\s(\w+)=(.*)/)) {
                // change a labs flag.
                var match1 = data.match(/^#flags\s(\w+)=(.*)/);
                data =
                    'var flags = JSON.parse(storageService.get("advancedSettings") || "{}"); flags["' +
                    match1[1].replace(/"/g, "'") +
                    '"]=' +
                    (match1[2] == 'null' ? 'undefined' : JSON.stringify(match1[2])) +
                    '; storageService.set("advancedSettings", JSON.stringify(flags)); $rootScope.$broadcast("advanced-settings-changed"); return flags;';
            } else if (data && data.match(/^#flags\s([\w\-]+)(\s([\d:]+))?$/)) {
                var match2 = data.match(/^#flags\s([\w\-]+)(\s([\d:]+))?$/);
                if (!match2[3]) {
                    data = 'self.onFeatureFlagsRequestInternal({type: "' + match2[1].replace(/"/g, "'") + '"});';
                    console.info(data);
                } else {
                    data =
                        'self.onFeatureFlagsRequestInternalAlt("' +
                        match2[1].replace(/"/g, "'") +
                        '", "' +
                        match2[3].replace(/"/g, "'") +
                        '");';
                }
            } else if (data && data.match(/^#params\s(.*)/)) {
                // change URL params - does not store in localStorage.
                var match3 = data.match(/^#params\s(.*)/);
                data = 'self.reloadWithNewParams("' + match3[1].replace(/"/g, "'") + '");';
            } else if (data == '#page-verify') {
                data = 'return self.layoutPageVerifyInvariants();';
            } else if (data == '#page-state') {
                data = 'return self.getLayoutPageState();';
            } else if (data == '#media-state') {
                data = 'return self.getMediaState();';
            } else if (data == '#media-quality') {
                data = 'self.getMediaQuality(function(value) { callback(value); });';
            } else if (data == '#videos') {
                data = 'return self.getVideosSnapshot();';
            } else if (data == '#layout-logs') {
                data = 'return self.layoutDebugLogs;';
            }

            return data;
        }

        function expandRemoteConsoleCallback(data, callback) {
            if (data == '#media-quality') {
                if (!callback) {
                    callback = function (value) {
                        console.info(
                            '<<< ' + JSON.stringify(value, null, self.formatRemoteConsoleResponse ? ' ' : null)
                        );
                        self.showStatsDisplayOnce(value);
                    };
                }
            } else if (data == '#videos') {
                if (!callback) {
                    callback = function (dataurl) {
                        self.showImageInNewTab(dataurl);
                    };
                }
            } else if (data == '#layout-logs') {
                if (!callback) {
                    callback = function (values) {
                        console.info(values.join('\n'));
                    };
                }
            }

            return callback;
        }

        function onRemoteConsoleRequest(msg) {
            var remoteFlags = configService.getServerValue('remoteFlags');
            if (
                helperService.getEnvironment() !== 'prod' &&
                !helperService.isElectron() &&
                remoteFlags == 'true' &&
                msg.data
            ) {
                logService.log('videoroomCtrl received remote-console-request from ' + msg.from);

                self.onInternalRemoteConsoleRequest(msg.data, function (data, logs) {
                    logService.log('videoroomCtrl sending remote-console-response to ' + msg.from);
                    socketService.send({
                        message: 'attendee-message',
                        data: { type: 'remote-console-response', to: msg.from, id: msg.id, data: data, logs: logs }
                    });
                });
            } else {
                logger.warn(
                    'onRemoteConsoleRequest',
                    'ignored received remote-console-request as remoteFlags is not enabled, or has invalid data.'
                );
            }
        }

        // authentication or other checks must happen before calling this function.
        function onInternalRemoteConsoleRequest(data, responseCallback) {
            var msgdata = expandRemoteConsoleRequest(data);

            var saved = { log: console.log, error: console.error, warn: console.warn };
            var logs = [];
            console.log =
                console.error =
                console.warn =
                    function () {
                        logs.push(
                            [].slice
                                .call(arguments)
                                .map(function (item) {
                                    return '' + item;
                                })
                                .join(' ')
                        );
                    };

            if (data && data.startsWith('#') && msgdata == data) {
                // failed to expand
                console.warn('Failed to expand ' + data + ', running as javascript');
            }

            var respond = function (data) {
                if (saved) {
                    console.log = saved.log;
                    console.error = saved.error;
                    console.warn = saved.warn;
                    saved = null;
                }
                responseCallback(data, logs);
            };

            var func;
            try {
                /*jslint evil: true */
                func = new Function(
                    'self',
                    '$window',
                    '$rootScope',
                    'attendeeService',
                    'attendeeListService',
                    'connectivityService',
                    'socketService',
                    'helperService',
                    'configService',
                    'storageService',
                    'callback',
                    msgdata
                );
            } catch (error) {
                console.log(error);
                respond();
                return;
            }

            var hasCallback = msgdata.match(/\bcallback\(/);
            var response;
            try {
                response = func(
                    self,
                    $window,
                    $rootScope,
                    attendeeService,
                    attendeeListService,
                    connectivityService,
                    socketService,
                    helperService,
                    configService,
                    storageService,
                    hasCallback ? respond : null
                );
            } catch (error) {
                console.log(error);
                respond();
                return; // to avoid double respond.
            }
            if (!hasCallback) {
                respond(response);
            }
        }

        function reloadWithNewParams(value) {
            var splitter = function (nv) {
                var index = nv.indexOf('=');
                return index < 0 ? [nv, ''] : [nv.substring(0, index), nv.substring(index + 1)];
            };
            var first = $window.location.search.substring(1).split('&').map(splitter); // existing params
            var second = value.split('&').map(splitter); // new params
            var combined = Object.fromEntries(first.concat(second)); // update existing with new params
            $window.location.search =
                '?' +
                Object.entries(combined)
                    .map(function (entry) {
                        // load with new params
                        return entry[0] + '=' + encodeURIComponent(entry[1]);
                    })
                    .join('&');
        }

        function showImageInNewTab(dataurl) {
            var image = new Image();
            image.src = dataurl;
            image.setAttribute('style', 'position: absolute; left: 0px; top: 0px;');
            var w = $window.open('');
            w.document.write(image.outerHTML);
        }

        // return a data url containing the snapshot image of the current video display approximation.
        function getVideosSnapshot() {
            var videos = $window.$('#videoroom-videos')[0];
            var width = videos.offsetWidth,
                height = videos.offsetHeight;
            var canvas = document.createElement('canvas');
            canvas.width = width;
            canvas.height = height;
            var items = $window.$('#videoroom-videos > div[user]:not(.audioonly)[enable="true"]');
            var ctx = canvas.getContext('2d');
            ctx.clearRect(0, 0, width, height);
            ctx.fillStyle = 'rgba(255,255,255,0.9)';
            ctx.fillRect(0, 0, width, height);
            items.each(function (index, item) {
                var video = $(item).find('video')[0];

                if (video) {
                    var dx = item.offsetLeft,
                        dy = item.offsetTop,
                        dw = item.offsetWidth,
                        dh = item.offsetHeight;
                    var sx = 0,
                        sy = 0,
                        sw = video.videoWidth,
                        sh = video.videoHeight;

                    ctx.fillStyle = '#000000';
                    ctx.fillRect(dx, dy, dw, dh);

                    if (sw && sh && dw > 0 && dh > 0) {
                        var sr = sw / sh,
                            dr = dw / dh;
                        if ($(item).hasClass('screen')) {
                            // object fit of contain
                            if (sr >= dr) {
                                // fit at width
                                dy = dy + dh / 2 - dw / (2 * sr);
                                dh = dw / sr;
                            } else {
                                // fit at height
                                dx = dx + dw / 2 - (dh * sr) / 2;
                                dw = dh * sr;
                            }
                        } else {
                            // object fit of cover
                            if (sr >= dr) {
                                // fit at height
                                sx = sx + sw / 2 - (dr * sh) / 2;
                                sw = dr * sh;
                            } else {
                                // fit at height
                                sy = sy + sh / 2 - sw / (2 * dr);
                                sh = sw / dr;
                            }
                        }
                        ctx.drawImage(
                            video,
                            Math.round(sx),
                            Math.round(sy),
                            Math.round(sw),
                            Math.round(sh),
                            Math.round(dx + 0.5),
                            Math.round(dy + 0.5),
                            Math.round(dw - 1),
                            Math.round(dh - 1)
                        );
                    }
                }

                ctx.font = '12px sans-serif';
                var text = $(item).attr('displayname');
                var textWidth = ctx.measureText(text).width;
                ctx.fillStyle = 'rgba(0,0,0,0.3)';
                ctx.fillRect(
                    item.offsetLeft,
                    item.offsetTop + item.offsetHeight - 20,
                    Math.min(textWidth + 8, item.offsetWidth),
                    20
                );
                ctx.textBaseline = 'bottom';
                ctx.fillStyle = '#ffffff';
                ctx.fillText(text, item.offsetLeft + 4, item.offsetTop + item.offsetHeight - 4, item.offsetWidth);
            });
            return canvas.toDataURL('image/jpeg', 0.8);
        }
    }
]);
